import { entregarArchivo } from "../../utils/entregarArchivo";
import {
    createAsyncThunk
} from '@reduxjs/toolkit';
import HttpManager from '../../services/HttpManager';

export const handleMentorsSalaryXlsx = createAsyncThunk(
    "attendances/handleMentorsSalaryXlsx",
    async ({ campusId, criteria }: any, { rejectWithValue }) => {
        try {
            const response = await http.fileService.getMentorsSalaryReport(campusId, criteria);
            await entregarArchivo(new Blob([response.data]), "Reporte Nómina de Profesores.xlsx", "Nómina de profesores");
            return { campusId, criteria };
        } catch (error: any) {
            return rejectWithValue(error.response);
        }
    }
);

const http = HttpManager.getInstance();